import styled from 'styled-components';

export const VideoIframe = styled.iframe`
  width: 100%;
  height: 100%;
`;
